import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ResourceManagementTabs } from './ResourceManagementTabs';

interface ResourceManagementModalProps {
  open: boolean;
  onClose: () => void;
  initialTab?: 'readings' | 'canvases' | 'papers';
}

export const ResourceManagementModal: React.FC<ResourceManagementModalProps> = ({
  open = false,
  onClose,
  initialTab = 'readings',
}) => {
  const [activeTab, setActiveTab] = React.useState<string>(initialTab);

  React.useEffect(() => {
    if (open) {
      setActiveTab(initialTab);
    }
  }, [open, initialTab]);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      aria-labelledby="resource-management-dialog-title"
    >
      <DialogTitle id="resource-management-dialog-title">
        Manage Resources
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="resource management tabs"
          >
            <Tab label="Readings" value="readings" />
            <Tab label="Canvases" value="canvases" />
            <Tab label="Papers" value="papers" />
          </Tabs>
        </Box>
        <ResourceManagementTabs activeTab={activeTab} />
      </DialogContent>
    </Dialog>
  );
};
